/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ArchiveTarget$Params {
  targetID?: number;
  doArchiveSubtargets?: boolean;
}

export function ArchiveTarget(http: HttpClient, rootUrl: string, params?: ArchiveTarget$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, ArchiveTarget.PATH, 'post');
  if (params) {
    rb.query('targetID', params.targetID, {});
    rb.query('doArchiveSubtargets', params.doArchiveSubtargets, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

ArchiveTarget.PATH = '/api/Supervisor/ArchiveTarget';
